// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--ubO5n","offers":"_02712f2b3b--offers--EMRck"};